export const tableStyles = {
  offersListFixedHeaderStyles: {
    tableStyle: {
      'font-size': '1.3rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(246,246,230)'
    },
    trStyle: {
      'border': '1px solid #cecece'
    },
    topHeaderStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(230, 232, 246)'
    }
  },
  offersListFixedDataStyle: {
    tableStyle: {
      'font-size': '1.3rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'white'
    },
    trStyle: {
      'border': '1px solid #cecece'
    },
    aStyle: {
      'cursor': 'pointer'
    },
    topHeaderStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(230, 232, 246)'
    }
  },
  offersListScrollableHeaderStyles: {
    tableStyle: {
      'font-size': '1.3rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(246,246,230)'
    },
    trStyle: {
      'border': '1px solid #cecece'
    }
  },
  offersListScrollableDataStyle: {
    tableStyle: {
      'font-size': '1.3rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'white'
    },
    trStyle: {
      'border': '1px solid #cecece'
    },
    aStyle: {
      'cursor': 'pointer'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/past-approval/tableStyles.js